<template>
  <div class="container">
    <el-form @submit.native.prevent class="form" :inline="true" :model="copyLabelForm" :rules="rules"
             ref="refCopyLabelForm">
      <el-form-item label="请扫描要复制的标签:" prop="trackingNo">
        <el-tooltip
          v-model="isShowBigChar"
          placement="bottom-start"
          effect="dark"
          content="大写锁定已打开"
          manual>
          <el-input
            ref="refTrayNo"
            autocomplete="off"
            clearable
            maxlength="50"
            v-model.trim="copyLabelForm.trackingNo"
            @keyup.enter.native="handleEnter"
            @keypress.native="onKeyPress">
          </el-input>
        </el-tooltip>
      </el-form-item>
      <el-form-item>
        <el-button
          :loading="loadingMain"
          type="primary"
          @click="submitForm">
          复制标签
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import {initLabelFrame, initBoxLabelFrame, generateBinLevelValue, printLabel} from '@/utils/label';
  import {getLabel} from '@/api/label';
  import {
    boxListGet
  } from '@/api/boxLabel';

  export default {
    data() {
      let validateTrackingNo = (rule, value, callback) => {
        const isEmptyValue = value === undefined || (typeof value === 'string' && !value.trim());
        if (isEmptyValue) {
          this.copyLabelForm.trackingNo = '';
          callback(new Error('标签不能为空'));
          return;
        }
        if (!(/^[A-Za-z0-9/$#@-]+$/.test(value))) {
          this.copyLabelForm.trackingNo = '';
          callback(new Error(`${value}标签格式错误`));
          return;
        }
        callback();
      };
      return {
        rules: {
          trackingNo: [{required: true, validator: validateTrackingNo, trigger: 'submit'}],
        },
        copyLabelForm: {
          trackingNo: ''
        },
        page: 1,
        perpage: 13,
        loadingMain: false,
        isShowBigChar: false,
      }
    },
    mounted() {
      this.$refs.refTrayNo && this.$refs.refTrayNo.focus();
      this.scanBoxInfoBarCode();
    },
    methods: {
      handleEnter() {
        this.submitForm();
      },
      scanBoxInfoBarCode() {
        let code = '';
        let nextCode;
        document.onkeypress = (e) => {
          nextCode = e.which;
          if (nextCode !== 13) {
            code += String.fromCharCode(nextCode);
          }
          if (nextCode === 13) {
            if (this.loadingMain) {
            } else if (this.$refs.refTrayNo && this.$refs.refTrayNo.focused) {
            } else {
              this.copyLabelForm.trackingNo = code;
              this.submitForm();
            }
            code = '';
          }
        };
      },
      submitForm() {
        this.$refs.refCopyLabelForm.validate(async (valid) => {
          if (valid) {
            this.getLabel(this.page, this.perpage);
          } else {
            this.copyLabelForm.trackingNo = '';
          }
        });
      },
      async getLabel(page, perpage) {
        this.loadingMain = true;
        try {
          let {
            trackingNo
          } = this.copyLabelForm;
          const trackingNoArray = trackingNo.split('#');
          const lastChar = trackingNo.substring(trackingNo.length - 1);
          const isBoxLabel = trackingNoArray[trackingNoArray.length - 1].length >= 7 && lastChar === 'B';
          let res;
          if (isBoxLabel) {
            res = await boxListGet({
              trackingNo: trackingNo,
              page,
              perpage
            });
          } else {
            res = await getLabel({
              page,
              perpage,
              trackingNo: trackingNo
            });
          }
          const data = res.data;
          if (data.count === 1 && data.info && data.info.length > 0) {
            const info = data.info[0];
            const {
              productName,
              chipName,
              binLevel,
              partNo,
            } = info;
            let binLevelValue = generateBinLevelValue({productName, partNo, chipName, binLevel});
            printLabel({...info, binLevelExplain: binLevelValue});
          } else {
            this.$message({
              type: 'error',
              message: `${trackingNo}标签信息有误，请检查标签`
            });
          }
          this.copyLabelForm.trackingNo = '';
        } catch (e) {
        } finally {
          this.loadingMain = false;
        }
      },
      onKeyPress(event) {
        let e = event || window.event;
        let keyCode = e.keyCode || e.which;
        let isShift = e.shiftKey || keyCode === 16 || false; //shift键是否按住
        if (((keyCode >= 65 && keyCode <= 90) && !isShift)
          || ((keyCode >= 97 && keyCode <= 122) && isShift)) {
          this.isShowBigChar = true;
        } else {
          this.isShowBigChar = false;
        }
      },
    }
  };
</script>
<style lang="less" scoped>
  .container {
    text-align: center;
  }

  .form {
    margin-top: 40px;
  }
</style>
